import React, {useState, useEffect} from "react";
import Button from '../../components/Button';
import {scrollTo} from '../../lib/utils';
import "./Home.css";

export default function Home (props) {
  const {setView, environment} = props;
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    if(!mounted){
      setMounted(true);
      scrollTo();
    }
  }, [mounted]);

  const imgXL = require("./img/keyvisual_login_mega.jpg");
  const imgL = require("./img/keyvisual_login_big.jpg");
  const imgM = require("./img/keyvisual_login_medium.jpg");
  const imgS = require("./img/keyvisual_login_small.jpg");
  const imgXS = require("./img/keyvisual_login_tiny.jpg");
  const srcset = imgXS+" 480w, "+imgS+" 640w, "+imgM+" 768w, "+imgL+" 1024w , "+imgXL+" 1600w";
  const origin = window.location.origin;
  const loginUrl = environment === "dev" ? null : `${origin}/login?ReturnUrl=${origin}/product-formulations/tools/emollients-jockey-tool`;
  //"https://www.carecreations.basf.com/login?ReturnUrl=https://www.carecreations.basf.com/":
  //"https://basf-carecreations-staging.aa-g.de/login?ReturnUrl=https://basf-carecreations-staging.aa-g.de/product-formulations/tools/emollients-jockey-tool");

  return (
    <section className="view home">
      <div className="stage">
        <ul className="slides">
          <li>
            <picture>
              <source srcSet={imgXL} media="(min-width: 1600px)"/>
              <source srcSet={imgL} media="(min-width: 1024px)"/>
              <source srcSet={imgM} media="(min-width: 768px)"/>
              <source srcSet={imgS} media="(min-width: 640px)"/>
              <source srcSet={imgXS}/>
              <img srcSet={srcset} src={imgXL} alt="Stage" />
            </picture>
          </li>
        </ul>
      </div>
      <div>
        <h1>The BASF’s Care Creations® Emollient Jockey</h1>
        <p>Increasing personalization continues to drive growth in the beauty industry.</p>
        <p>BASF’s Care Creations® Emollient Jockey enables users to find the right emollient, and places the whole array of sensory variants at their fingertips.</p>
        <div>
           <Button
             rounded
             big
             blueBright
             label="Login with Federation Service"
             href={loginUrl}
             onClick={loginUrl ? null : (e) => {e.preventDefault(); setView("list")}}
           />
        </div>
      </div>
    </section>
  )
}
